import React, { useContext } from 'react';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #EBEBEB;
  margin-top: 30px;
`;

const SectionTitle = styled.span`
  color: #F1A857;
  font-size: 18px;
  padding: 14px 16px;
  display: block;
  font-weight: 600;
`

const Block = styled.div`
  width: 100%;
  display: flex;
  padding: 14px 16px;
  font-size: 14px;
  box-sizing: border-box;
  a {
    border: 3px solid #F1A857;
    border-radius: 3px;
    height: 55px;
    display: block;
    width: 100%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    &:hover {
      background: #F1A857;
      .icone {
        border-color: #E0933D;
      }
      .texto {
        color: #fff;
      }
    }
    .icone {
      border-right: 1px solid #F1A857;
      width: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin-right: 20px;
      i {
        height: 30px;
        width: 30px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .texto {
      align-items: center;
      display: flex;
      font-size: 14px;
      color: #6A6A6A;
      letter-spacing: 0.31px;
    }
  }
`

const BoxDownloads = ({downloads}) => {
  const { language } = useContext(LanguageContext);
  let downloadsText = ''
  switch (language) {
    case 'pt-br':
      downloadsText = 'Downloads';
      break;
    case 'en-us':
      downloadsText = 'Downloads';
      break;
    case 'es-es':
      downloadsText = 'Descargar';
      break;
    default:
  }
  return (
    <Container>
      <SectionTitle>{ downloadsText }</SectionTitle>
      {
        downloads.map((item, index) => {
          return (
            <Block key={ index }>
              <a href={ item.download.url } target="_blank" rel="noopener noreferrer">
                <span className="icone">
                  <i style={ { backgroundImage: `url(${item.icone_botao.url})`}}></i>
                </span>
                <span className="texto">
                  { item.texto_botao }
                </span>
              </a>
            </Block>
          )
        })
      }
    </Container>
  );
}

export default BoxDownloads;
